module.exports = __webpack_public_path__ + "assets/img/413fbb2701de51a4223c154d5027d3b8.png";